import { Box, Button, Drawer } from '@mui/material';

import { HideSidebar, ShowSidebar } from './images/SideBarIcon';

export const enum SideBarState {
    none,
    close,
    open,
}

export interface SideBarProps {
    state: SideBarState;
    setState: (state: SideBarState) => void;
}

export function SideBarButton(props: SideBarProps) {
    switch (props.state) {
        case SideBarState.none:
            return <Box sx={{ width: 64 }} />;
        case SideBarState.close:
            return (
                <Button onClick={() => props.setState(SideBarState.open)}>
                    <ShowSidebar sx={{ width: 16, height: 16 }} />
                </Button>
            );
        case SideBarState.open:
            return (
                <Button onClick={() => props.setState(SideBarState.close)}>
                    <HideSidebar sx={{ width: 16, height: 16 }} />
                </Button>
            );
    }
}
